import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  public retrieveProcessTable = new BehaviorSubject<boolean>(false);
  public retrieveProcessTable$ = this.retrieveProcessTable.asObservable();

  constructor(private httpService: HttpService) {}

  getProcesses(params: any): Observable<any> {
    return this.httpService.get('process', { params });
  }

  getProcess(id: number): Observable<any> {
    return this.httpService.get(`process/${id}`);
  }

  getProcessIndicatorByProcessIdAndAllocationTypeId(processId: number, allocationTypeId: number): Observable<any> {
    return this.httpService.get(`process/${processId}/indicator/${allocationTypeId}`);
  }

  getProcessIndicator(indicatorId: number): Observable<any> {
    return this.httpService.get(`process/indicator/${indicatorId}`);
  }

  addOrUpdateProcessIndicator(payload: any): Observable<any> {
    return this.httpService.post(`process/indicator`, payload);
  }

  deleteProcessIndicator(indicatorId: number): Observable<any> {
    return this.httpService.delete(`process/indicator/${indicatorId}`);
  }

  importProcess(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpService.post('process/import', formData);
  }

  exportProcesses(ids: number[]): Observable<any> {
    return this.httpService.downloadFile(`process/export`,  ids);
  }

  addOrUpdateProcess(payload: any): Observable<number> {
    return this.httpService.post('process', payload);
  }

  deleteProcess(ids: number[]): Observable<boolean> {
    return this.httpService.post(`process/delete`, ids);
  }
}
